import * as React from 'react';
const SvgTarget = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 6.364a3.636 3.636 0 1 0 0 7.272 3.636 3.636 0 0 0 0-7.272m8.127 2.727a8.18 8.18 0 0 0-7.218-7.218V0H9.091v1.873A8.18 8.18 0 0 0 1.873 9.09H0v1.818h1.873a8.176 8.176 0 0 0 7.218 7.214v1.872h1.818v-1.872a8.18 8.18 0 0 0 7.218-7.219H20V9.087zM10 16.364a6.364 6.364 0 1 1 0-12.728 6.364 6.364 0 0 1 0 12.728" />
  </svg>
);
export default SvgTarget;
